$(() => {
    if ($('#way-map').length > 0) {
        var coord = $('#way-map').attr('data-map');
        ymaps.ready(function () {
            var myMap = new ymaps.Map('way-map', {
                center: coord,
                zoom: 9
            });

            myMap.controls.add('routePanelControl', {
                autofocus: false,
            });

            var control = myMap.controls.get('routePanelControl');

            // Зададим состояние панели для построения машрутов.
            control.routePanel.state.set({
                // Тип маршрутизации.
                type: 'masstransit',
                // Выключим возможность задавать пункт отправления в поле ввода.
                fromEnabled: false,
                // Адрес или координаты пункта отправления.
                to: coord,
                // Включим возможность задавать пункт назначения в поле ввода.
                fromEnabled: true
                // Адрес или координаты пункта назначения.
                //to: 'Петербург'
            });

            // Зададим опции панели для построения машрутов.
            control.routePanel.options.set({
                // Запрещаем показ кнопки, позволяющей менять местами начальную и конечную точки маршрута.
                allowSwitch: false,
                // Включим определение адреса по координатам клика.
                // Адрес будет автоматически подставляться в поле ввода на панели, а также в подпись метки маршрута.
                reverseGeocoding: true,
                // Зададим виды маршрутизации, которые будут доступны пользователям для выбора.
                types: { masstransit: false, pedestrian: false, auto: true }
            });
        });

        $('.way-click').on('click', function()  {
            $('.way-map').removeClass('active');
            $(this).css('display', 'none');
            $('.ymaps-2-1-64-route-panel-input__input').focus();
            $('.parking-block').addClass('parking-block--active');
        });
    }


    if ($('#way-map-next').length > 0) {
        var coord = $('#way-map-next').attr('data-map');
        ymaps.ready(function () {
            var myMap = new ymaps.Map('way-map-next', {
                center: coord,
                zoom: 9
            });

            myMap.controls.add('routePanelControl', {
                autofocus: false,
            });

            var control = myMap.controls.get('routePanelControl');

            // Зададим состояние панели для построения машрутов.
            control.routePanel.state.set({
                // Тип маршрутизации.
                type: 'masstransit',
                // Адрес или координаты пункта отправления.
                from: coord,
                // Включим возможность задавать пункт назначения в поле ввода.
                toEnabled: true
                // Адрес или координаты пункта назначения.
                //to: 'Петербург'
            });

            // Зададим опции панели для построения машрутов.
            control.routePanel.options.set({
                // Запрещаем показ кнопки, позволяющей менять местами начальную и конечную точки маршрута.
                allowSwitch: false,
                // Включим определение адреса по координатам клика.
                // Адрес будет автоматически подставляться в поле ввода на панели, а также в подпись метки маршрута.
                reverseGeocoding: true,
                // Зададим виды маршрутизации, которые будут доступны пользователям для выбора.
                types: { masstransit: false, pedestrian: false, auto: true }
            });
        });

        $('.way-click').on('click', function()  {
            $('.way-map').removeClass('active');
            $(this).css('display', 'none');
            $('.ymaps-2-1-64-route-panel-input__input').focus();
            $('.parking-block').addClass('parking-block--active');
        });
    }
});



// WEBPACK FOOTER //
// ./src/scripts/components/way/way.js